<template>
  <el-drawer
    class="modal-wrapper"
    :visible.sync="showDrawer"
    size="90%"
    :modal="false"
    :withHeader="false"
    :destroy-on-close="true"
    @closed="activeTab = 'data'"
  >
    <div class="modal-contents">
      <div class="drawer-header">
        <el-page-header @back="goBack"> </el-page-header>
        <div class="header-infos">
          <div class="rows">
            <div class="row">
              <label>计划名称：</label>
              <p
                v-if="info.planName"
                class="info-mini"
                v-clipboard:copy="info.planName"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                {{ info.planName }}
              </p>
            </div>

            <div class="row">
              <label>PlanID：</label>
              <p v-if="info.planId">{{ info.planId }}</p>
            </div>

            <div class="row">
              <label>SourceID：</label>
              <p v-if="info.sourceId">{{ info.sourceId }}</p>
            </div>

            <div class="row">
              <label>媒体计划ID：</label>
              <p v-if="info.adId">{{ info.adId }}</p>
            </div>

            <div class="row">
              <label>媒体：</label>
              <p v-if="info.mediaName">{{ info.mediaName }}</p>
            </div>

            <div class="row">
              <label>媒体ID：</label>
              <p v-if="info.mediaId">{{ info.mediaId }}</p>
            </div>

            <div class="row">
              <label>投放位：</label>
              <p
                v-if="info.advertPosiName"
                class="info-mini"
                v-clipboard:copy="info.advertPosiName"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                {{ info.advertPosiName }}
              </p>
            </div>

            <div class="row">
              <label>游戏名称：</label>
              <p
                v-if="info.productName"
                class="info-mini"
                v-clipboard:copy="info.productName"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                {{ info.productName }}
              </p>
            </div>

            <div class="row">
              <label>游戏ID：</label>
              <p v-if="info.productId">{{ info.productId }}</p>
            </div>

            <div class="row">
              <label>账号：</label>
              <p v-if="info.adAccountId">{{ info.adAccountId }}</p>
            </div>

            <div class="row">
              <label>计划主ID：</label>
              <p v-if="info.advertiserId">{{ info.advertiserId }}</p>
            </div>

            <div class="row">
              <label>投放人员：</label>
              <p v-if="info.name">{{ info.name }}</p>
            </div>
          </div>

          <div class="right-date-range">
            <DateRangePicker v-model="info.dateTime" style="width: 220px"></DateRangePicker>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="left-side-bar">
          <div class="left-tabs">
            <div class="tabs">
              <div v-for="tab in tabs" :key="tab.key" @click="activeTab = tab.key" :class="{ active: activeTab === tab.key }" class="tab">
                {{ tab.label }}
              </div>
            </div>
          </div>
        </div>

        <div class="tab-content">
          <div class="panel data-panel"><DataPanel v-if="activeTab === 'data'" v-bind="{ ...panelProps }" /></div>
          <div class="panel user-panel"><UserPanel v-if="activeTab === 'user'" v-bind="{ ...panelProps }" /></div>
          <div class="panel material-panel"><MaterialPanel v-if="activeTab === 'material'" v-bind="{ ...panelProps }" /></div>
          <div class="panel ad-position-panel"><AdPositionPannel v-if="activeTab === 'adposition'" v-bind="{ ...panelProps }" /></div>
          <div class="panel log-panel"><LogPanel v-if="activeTab === 'log'" v-bind="{ ...panelProps }" /></div>
          <div class="panel detail-panel"><DetailPanel v-if="activeTab === 'detail'" v-bind="{ ...panelProps }" /></div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import UserPanel from './detail-tabs/user.vue'
import DataPanel from './detail-tabs/data.vue'
import LogPanel from './detail-tabs/log.vue'
import MaterialPanel from './detail-tabs/material.vue'
import DetailPanel from './detail-tabs/detail.vue'
import AdPositionPannel from './detail-tabs/ad-position.vue'
import DateRangePicker from '@/components/date-range-picker/index.vue'

export default {
  components: { DateRangePicker, UserPanel, DataPanel, LogPanel, MaterialPanel, DetailPanel, AdPositionPannel },
  props: {
    value: {
      type: Boolean
    },
    info: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    panelProps() {
      const { platform, productId, chlUserId, sourceId, creativeIds, adId, adAccountId, mediaId, subMediaId, planId, planName, dateTime } = this.info
      return { platform, productId, chlUserId, sourceId, creativeIds, adId, adAccountId, mediaId, subMediaId, planId, planName, detailTime: dateTime }
    },
    showDrawer: {
      get() {
        return this.value
      },

      set(v) {
        this.$emit('input', v)
      }
    }
  },
  data() {
    return {
      tabs: [
        { label: '分日数据', key: 'data' },
        { label: '用户', key: 'user' },
        { label: '素材数据', key: 'material' },
        { label: '投放位数据', key: 'adposition' },
        { label: '操作日志', key: 'log' },
        { label: '导量详情', key: 'detail' }
      ],
      activeTab: 'data'
    }
  },
  methods: {
    goBack() {
      this.showDrawer = false
    },
    onCopy() {
      this.$Message.success('复制成功！')
    },
    onError() {
      this.$Message.warning('剪切板禁止访问')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

.modal-wrapper {
  position: absolute;
  .modal-contents {
    height: 100%;
  }

  .drawer-header {
    position: relative;
    display: flex;
    border-bottom: 1px solid #ddd;

    ::v-deep .el-page-header {
      background: #eee;
      &:hover {
        color: #999;
      }
      .el-page-header__left {
        align-items: center;
        margin-right: 0;
        padding: 0 15px;
        &::after {
          display: none;
        }
        .el-page-header__title {
          white-space: nowrap;
        }
      }
    }

    .header-infos {
      padding: 5px 10px;
      display: flex;

      .rows {
        display: flex;
        flex-wrap: wrap;
        .row {
          display: flex;
          margin-right: 15px;
          line-height: 18px;
          label {
            font-weight: 700;
          }
        }
      }
    }
  }

  @mixin tab-active {
    background: $primary-color;
    color: #fff;
  }

  .main {
    display: flex;
    height: calc(100% - 47px);
    .left-side-bar {
      background: #eee;
      width: 82px;
      min-width: 82px;

      .tabs {
        .tab {
          line-height: 26px;
          padding: 20px 0;
          cursor: pointer;
          text-align: center;
          &.active {
            @include tab-active;
          }
          &:hover {
            @include tab-active;
            background: rgba($primary-color, 0.75);
          }
        }
      }
    }

    .tab-content {
      width: calc(100% - 82px);
      .panel {
        padding: 0 10px;
      }
    }
  }
}
</style>
